import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTabsModule } from '@angular/material/tabs';

import { FilePondModule, registerPlugin } from 'ngx-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
registerPlugin(FilePondPluginFileValidateType);
registerPlugin(FilePondPluginFileValidateSize);
registerPlugin(FilePondPluginImagePreview);
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

// TinyMCE (self-hosted). Importing the core sets the global `tinymce` so the
// editor component never reaches out to TinyMCE Cloud; themes/icons/models/
// plugins/skins are lazy-loaded at runtime from the copied assets via the
// `base_url` set on the editor init (see EventConfigComponent.editorInit).
import 'tinymce/tinymce.min.js';
import { EditorModule } from '@tinymce/tinymce-angular';

import { EventConfigComponent } from './event-config.component';
import { AutoGrowDirective } from './auto-grow.directive';
import { InlineRichEditComponent } from './inline-rich-edit.component';

@NgModule({
  imports: [CommonModule, FormsModule, BrowserAnimationsModule, MatTabsModule, FilePondModule, EditorModule],
  exports: [EventConfigComponent],
  declarations: [EventConfigComponent, AutoGrowDirective, InlineRichEditComponent],
  providers: [],
})
export class EventConfigModule {}
